import { render, staticRenderFns } from "./visits.vue?vue&type=template&id=1f8071b8&"
import script from "./visits.vue?vue&type=script&lang=js&"
export * from "./visits.vue?vue&type=script&lang=js&"
import style0 from "./visits.vue?vue&type=style&index=0&id=1f8071b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports